module.exports = __webpack_public_path__ + "img/reedimg.f2c8f9bf.png";